export default __webpack_public_path__ + "static/media/banner_desafio_edutech.5e0283d2.png";